$('.c-numbers').each(function() {
  var $this          = $(this),
      elementWatcher = scrollMonitor.create($this, -100);
  elementWatcher.enterViewport(function() {
    var $counters = $this.find('.c-numbers__counter');
    $this.addClass('active');
    $counters.each(function(){
      var $counter  = $(this),
      value         = $counter.data('value'),
      decimals      = $counter.data('decimals'),
      start         = {var: 0};
      TweenMax.to(start, 2, {
        var: value,
        onUpdate: function() {
          $counter.html((start.var).toFixed(decimals));;
        },
        ease:Circ.easeOut
      });
    })
  });
  elementWatcher.exitViewport(function() {
    $this.removeClass('active');
});
});
